export const practices_CreateContent = [
	{
		icon: '✅',
		title: 'practicesData.title1',
		subtitle: 'practicesData.subtitle1',
	},
	{
		icon: '✅',
		title: 'practicesData.title2',
		subtitle: 'practicesData.subtitle2',
	},
	{
		icon: '✅',
		title: 'practicesData.title3',
		subtitle: 'practicesData.subtitle3',
	},
	{
		icon: '✅',
		title: 'practicesData.title4',
		subtitle: 'practicesData.subtitle4',
	},
	{
		icon: '✅',
		title: 'practicesData.title5',
		subtitle: 'practicesData.subtitle5',
	},
];
